// src/app/services/invitation.service.ts

import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { InvitationResponse } from '../models/invitation-response.model';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvitationService {

  private apiUrl = `${environment.apiUrl}/invitations`;

  //private apiUrl = 'http://localhost:8080/api/invitations'; // Adjust as needed

  constructor(private http: HttpClient) { }

  /**
   * Fetches the invitation details without accepting it.
   * @param token The invitation token.
   * @returns An Observable of InvitationResponse.
   */
  getInvitation(token: string): Observable<InvitationResponse> {
    return this.http.get<InvitationResponse>(`${this.apiUrl}/${token}`).pipe(
      catchError(this.handleError)
    );
  }

  /**
   * Handles HTTP errors.
   * @param error The HTTP error response.
   * @returns An Observable that throws an error message.
   */
  private handleError(error: HttpErrorResponse) {
    let errorMsg = '';
    if (error.error instanceof ErrorEvent) {
      // Client-side or network error
      errorMsg = `An error occurred: ${error.error.message}`;
    } else {
      // Backend returned an unsuccessful response code
      errorMsg = error.error.message || 'Server returned an error.';
    }
    return throwError(() => errorMsg);
  }

}
